module.exports = __webpack_public_path__ + "img/poster-ru40x20.0d035eee.jpg";